import { Controller } from '@hotwired/stimulus'
import { delay } from '../utilities'

export default class extends Controller {
  static targets = [
    'formButton',
    'yesButton',
    'noButton',
    'reasons',
    'thankYouMessage',
    'main'
  ]

  static values = { articleKey: String, localStorageKey: String }

  connect() {
    const feedbackData = localStorage.getItem(this.localStorageKeyValue)
    if (!feedbackData) return

    const feedback = JSON.parse(feedbackData)
    const choice = feedback[this.articleKeyValue]
    if (choice) this.element.remove()
  }

  async setChoice(event) {
    if (this.choice) return // prevent duplicate/quick clicks

    this.choice = event.params.choice

    if (this.choice === 'yes') {
      this.yesButtonTarget.classList.add('pointer-events-none')
      this.yesButtonTarget.dataset.loading = true
      this.#capturePostHogEvent()
      this.#setLocalStorageData()
      await delay(1000)
      this.#showThankYouMessage()
    } else {
      this.#highlightNoButton()
      this.reasonsTarget.hidden = false
    }
  }

  async submitReasonForm(event) {
    event.preventDefault()
    this.formButtonTarget.dataset.loading = true
    const formData = new FormData(event.target)
    const reason = formData.get('unhelpful-reason')
    this.#capturePostHogEvent(reason)
    this.#setLocalStorageData()
    await delay(1000)
    this.#showThankYouMessage()
  }

  #capturePostHogEvent(reason) {
    const data = { helpful: this.choice === 'yes' }
    if (this.choice === 'no') data.reason = reason

    try {
      posthog.capture('help_docs:feedback_submitted', data)
    } catch (e) {
      console.warn('Unable to capture PostHog event.', e)
    }
  }

  #highlightNoButton() {
    this.yesButtonTarget.classList.add(
      'animate-fade-out',
      'pointer-events-none'
    )

    const noButtonOffset = this.noButtonTarget.offsetLeft
    this.noButtonTarget.dataset.selected = 'true'
    this.noButtonTarget.style.transition = '0.6s ease'
    this.noButtonTarget.style.translate = `-${noButtonOffset}px 0`
  }

  #setLocalStorageData() {
    const storageKey = this.localStorageKeyValue
    const existing = localStorage.getItem(storageKey)
    const feedback = existing ? JSON.parse(existing) : {}
    feedback[this.articleKeyValue] = this.choice
    localStorage.setItem(storageKey, JSON.stringify(feedback))
  }

  async #showThankYouMessage() {
    this.mainTarget.remove()
    this.thankYouMessageTarget.hidden = false
    await delay(100)
    this.thankYouMessageTarget.classList.remove('opacity-0')
  }
}
